import { BASE_URL } from 'config/urls';

import { callUrl, get, post } from 'utils/sdk';

export const logout = () => callUrl(post, `${BASE_URL}/v1/auth/logout/`);

export const getUnseenNotificationsCount = () =>
  callUrl(get, `${BASE_URL}/v1/trackers/notifications/student/unseen/`);
